import { render, staticRenderFns } from "./Attention.vue?vue&type=template&id=0bd70286&scoped=true&"
import script from "./Attention.vue?vue&type=script&lang=ts&"
export * from "./Attention.vue?vue&type=script&lang=ts&"
import style0 from "./Attention.vue?vue&type=style&index=0&id=0bd70286&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd70286",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VDialog})
